import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// Components
import { LoadingSpinner } from 'wg-fe-ui';
import VehicleMobileItem from './VehicleMobileItem';

// Types
import { VersionsProps } from './VehicleLookupOrderTable';
import { Model } from '../../../../types/SMT';

interface Props {
  versions: VersionsProps[];
  selected?: string;
  searchLoading: boolean;
  noResults: boolean;
  isAppending: boolean;
  handleSelectedCar: (b: string, m: string, v: string) => void;
  model: Model;
}

const VehicleMobileList: React.FC<React.PropsWithChildren<Props>> = ({
  versions,
  selected,
  handleSelectedCar,
  searchLoading,
  noResults,
  model,
}) => {
  const { t } = useTranslation();

  const handleOnSelected = (_id: string) => {
    const car = versions.find(({ id }) => id === _id);
    if (car) {
      handleSelectedCar(car.brand, model.id, car.id);
    }
  };

  return searchLoading ? (
    <CenteredLoadingWrapper>
      <LoadingSpinner />
    </CenteredLoadingWrapper>
  ) : versions?.length === 0 || noResults ? (
    <NoResults>{t('No results')}</NoResults>
  ) : (
    <Wrapper>
      {versions.map((props) => (
        <VehicleMobileItem
          key={props.id}
          {...props}
          isSelected={selected === props.id}
          onSelected={handleOnSelected}
        />
      ))}
    </Wrapper>
  );
};

const NoResults = styled.div`
  font-size: 2.1rem;
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
`;

const CenteredLoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const Wrapper = styled.ul`
  > div:not(:last-of-type) {
    margin-bottom: 0.8rem;
  }
`;

export default VehicleMobileList;
